module.exports = __webpack_public_path__ + "img/fe_backdrop_emblem.8f039719.png";